import { ERRORS } from '../core/Consts';
import Global from './global';
import Auth from './auth';
import Prod from './prod';
import Order from './order';
import Home from './home';
import User from './user';
import Visa from './visa';
import Subject from './subject';
import Destination from './destination';
import Search from './search';
import Coupon from './coupon';
import signup from './signup';
import qrcode from './qrcode';
import exam from './exam';
import pet from './pet';
import adjustLeave from './adjustLeave';

const ACTION = wrapExceptionHandler({
  ...Global.ACTION,
  ...Auth.ACTION,
  ...Prod.ACTION,
  ...Order.ACTION,
  ...Home.ACTION,
  ...User.ACTION,
  ...Visa.ACTION,
  ...Subject.ACTION,
  ...Destination.ACTION,
  ...Search.ACTION,
  ...Coupon.ACTION,
  ...signup.ACTION,
  ...qrcode.ACTION,
  ...exam.ACTION,
  ...pet.ACTION,
  ...adjustLeave.ACTION,
});

const ACTION_TYPES = {
  ...ERRORS,
  ...Global.ACTION_TYPES,
  ...Auth.ACTION_TYPES,
  ...Prod.ACTION_TYPES,
  ...Order.ACTION_TYPES,
  ...Home.ACTION_TYPES,
  ...User.ACTION_TYPES,
  ...Visa.ACTION_TYPES,
  ...Subject.ACTION_TYPES,
  ...Destination.ACTION_TYPES,
  ...Search.ACTION_TYPES,
  ...Coupon.ACTION_TYPES,
  ...signup.ACTION_TYPES,
  ...qrcode.ACTION_TYPES,
  ...exam.ACTION_TYPES,
  ...pet.ACTION_TYPES,
  ...adjustLeave.ACTION_TYPES,
};

function wrapExceptionHandler(actions) {
  const retActions = {};
  Object.keys(actions).forEach((key) => {
    const handler = actions[key];
    retActions[key] = async (...args) => {
      try {
        const result = await handler.apply(this, args);
        return result;
      } catch (response) {
        let type = ERRORS.ERROR_500;
        if (response.status !== 200) {
          switch (response.code) {
            case 401:
            case '-401':
            case -401:
              type = ERRORS.ERROR_401;
              break;
            default:
              type = ERRORS.ERROR_500;
          }
        } else {
          type = ERRORS.ERROR_BIZ;
          if (response.code === -401) {
            type = ERRORS.ERROR_401;
          }
        }
        return {
          type,
          payload: response
        };
      }
    };
  });

  return retActions;
}

export default ACTION;
export { ACTION_TYPES };
